module.exports = __webpack_public_path__ + "media/images/menu/leo_minor-90eab607fc8d33569a549c2c66e9ad89.jpg";